<script>
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
export default {
  mixins: [Api, Sabit],
  props: ["RiskId","Guncelle"],
  data() {
    return {
      Page: {
        PageNumber: "1",
        PageSize: "9999",
        PageDataSize: "1",
      },
      TableData: [],
    };
  },
  methods: {
    Get() {
      let Filter = "&Riskid=" + this.RiskId;
      this.ActionsFilterGet({ Service: "StrRiskBirim", Page: this.Page, Filter: Filter }).then((res) => {
        this.TableData = res.Data;
        this.Page.PageDataSize = res.TotalCount;
      });
    },
  },
 
  watch: {
    Guncelle() {
        this.Get();
      }

    },
};
</script>
<template>
  <div>
    <table class="table mb-0">
      <thead>
        <tr>
          <th scope="col">{{ $t("StrRiskBirim.Table.BirimAdis") }}</th>
          <th scope="col" style="width: 85px; text-align: center; vertical-align: middle;">{{ $t("StrRiskBirim.Table.Islem") }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="Data in TableData" :key="Data.Id">
          <td>{{ Data.BirimAdis.join(", ") }}</td>
          <td style="width: 85px; text-align: center; vertical-align: middle;">
            <b-button-group>
              <b-button variant="primary" @click="$emit('Id', Data)"><i class="fa fa-pencil-alt"></i></b-button>
              <!--<b-button variant="danger" @click="Delete('StrRiskBirim', Data.Id)"><i class="fa fa-trash-alt"></i>
              </b-button>-->
            </b-button-group>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
